/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportCreationInterval } from './ReportCreationInterval';
import {
    ReportCreationIntervalFromJSON,
    ReportCreationIntervalFromJSONTyped,
    ReportCreationIntervalToJSON,
    ReportCreationIntervalToJSONTyped,
} from './ReportCreationInterval';
import type { ReportConfigLayoutRepresentation } from './ReportConfigLayoutRepresentation';
import {
    ReportConfigLayoutRepresentationFromJSON,
    ReportConfigLayoutRepresentationFromJSONTyped,
    ReportConfigLayoutRepresentationToJSON,
    ReportConfigLayoutRepresentationToJSONTyped,
} from './ReportConfigLayoutRepresentation';
import type { ReportReferenceDate } from './ReportReferenceDate';
import {
    ReportReferenceDateFromJSON,
    ReportReferenceDateFromJSONTyped,
    ReportReferenceDateToJSON,
    ReportReferenceDateToJSONTyped,
} from './ReportReferenceDate';

/**
 * 
 * @export
 * @interface ReportConfigRepresentation
 */
export interface ReportConfigRepresentation {
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    dashboardKey: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    reportType: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    subtitle: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigRepresentation
     */
    createAutomatically: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportConfigRepresentation
     */
    createAt?: number;
    /**
     * 
     * @type {ReportCreationInterval}
     * @memberof ReportConfigRepresentation
     */
    creationInterval?: ReportCreationInterval;
    /**
     * 
     * @type {ReportReferenceDate}
     * @memberof ReportConfigRepresentation
     */
    referenceDate?: ReportReferenceDate;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigRepresentation
     */
    sentToEmail?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    layoutGenerationPolicy: string;
    /**
     * 
     * @type {Array<ReportConfigLayoutRepresentation>}
     * @memberof ReportConfigRepresentation
     */
    layouts?: Array<ReportConfigLayoutRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof ReportConfigRepresentation
     */
    storeInDocuments: boolean;
    /**
     * The ISO 639 code for the language of the report
     * @type {string}
     * @memberof ReportConfigRepresentation
     */
    language?: string;
}



/**
 * Check if a given object implements the ReportConfigRepresentation interface.
 */
export function instanceOfReportConfigRepresentation(value: object): value is ReportConfigRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('dashboardKey' in value) || value['dashboardKey'] === undefined) return false;
    if (!('reportType' in value) || value['reportType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subtitle' in value) || value['subtitle'] === undefined) return false;
    if (!('createAutomatically' in value) || value['createAutomatically'] === undefined) return false;
    if (!('layoutGenerationPolicy' in value) || value['layoutGenerationPolicy'] === undefined) return false;
    if (!('storeInDocuments' in value) || value['storeInDocuments'] === undefined) return false;
    return true;
}

export function ReportConfigRepresentationFromJSON(json: any): ReportConfigRepresentation {
    return ReportConfigRepresentationFromJSONTyped(json, false);
}

export function ReportConfigRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportConfigRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'dashboardKey': json['dashboardKey'],
        'reportType': json['reportType'],
        'title': json['title'],
        'subtitle': json['subtitle'],
        'createAutomatically': json['createAutomatically'],
        'createAt': json['createAt'] == null ? undefined : json['createAt'],
        'creationInterval': json['creationInterval'] == null ? undefined : ReportCreationIntervalFromJSON(json['creationInterval']),
        'referenceDate': json['referenceDate'] == null ? undefined : ReportReferenceDateFromJSON(json['referenceDate']),
        'sentToEmail': json['sentToEmail'] == null ? undefined : json['sentToEmail'],
        'layoutGenerationPolicy': json['layoutGenerationPolicy'],
        'layouts': json['layouts'] == null ? undefined : ((json['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationFromJSON)),
        'storeInDocuments': json['storeInDocuments'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function ReportConfigRepresentationToJSON(json: any): ReportConfigRepresentation {
    return ReportConfigRepresentationToJSONTyped(json, false);
}

export function ReportConfigRepresentationToJSONTyped(value?: ReportConfigRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'dashboardKey': value['dashboardKey'],
        'reportType': value['reportType'],
        'title': value['title'],
        'subtitle': value['subtitle'],
        'createAutomatically': value['createAutomatically'],
        'createAt': value['createAt'],
        'creationInterval': ReportCreationIntervalToJSON(value['creationInterval']),
        'referenceDate': ReportReferenceDateToJSON(value['referenceDate']),
        'sentToEmail': value['sentToEmail'],
        'layoutGenerationPolicy': value['layoutGenerationPolicy'],
        'layouts': value['layouts'] == null ? undefined : ((value['layouts'] as Array<any>).map(ReportConfigLayoutRepresentationToJSON)),
        'storeInDocuments': value['storeInDocuments'],
        'language': value['language'],
    };
}

